import React from 'react';

const Share = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512.001 512.001"
            {...props}
        >
            <path d="M416.667 321.333c-31.877 0-60.146 15.729-77.465 39.832L186.253 284.69c2.864-9.059 4.414-18.696 4.414-28.69s-1.55-19.632-4.415-28.69l152.95-76.475c17.318 24.102 45.588 39.832 77.465 39.832 52.567 0 95.334-42.767 95.334-95.334C512 42.767 469.234 0 416.667 0c-52.566 0-95.332 42.767-95.332 95.333a94.97 94.97 0 004.414 28.688l-152.952 76.476c-17.317-24.102-45.587-39.83-77.462-39.83C42.766 160.667 0 203.434 0 256s42.766 95.333 95.334 95.333c31.875 0 60.145-15.73 77.463-39.83l152.951 76.476a94.976 94.976 0 00-4.414 28.689c0 52.566 42.766 95.333 95.332 95.333C469.234 512 512 469.233 512 416.667c0-52.567-42.766-95.334-95.333-95.334z" />
        </svg>
    )
}

export default Share;
